import { GameInProgress } from 'components/main/section-router/game-in-progress';
import { Unavailable } from 'components/main/section-router/unavailable';
import { SectionName } from 'enums/route.enums';
import { useNavSections } from 'hooks/useNavSections';
import { ReactElement } from 'react';

/**
 * Skip mounting a section tree when it is not in the visible nav catalog.
 */
export const SectionGate = ({
  section,
  children,
}: {
  section: SectionName;
  children: ReactElement;
}): ReactElement => {
  const { isSectionAvailable, isBlockedByGame } = useNavSections();

  if (isSectionAvailable(section)) {
    return children;
  }

  if (isBlockedByGame(section)) {
    return <GameInProgress />;
  }

  return <Unavailable />;
};
